import { useQueryClient, useMutation } from "@tanstack/react-query";
import { http } from "../../../utils";

async function addProductInquiryAnswer({ id, answer }) {
  const data = await http(`/admin/product-inquiry/${id}/answer`, {
    data: { answer },
  });
  return data;
}

export function useAddProductInquiryAnswer() {
  const queryClient = useQueryClient();

  return useMutation(addProductInquiryAnswer, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-inquiry-detail"]);
    },
  });
}
